import { useQuery } from '@tanstack/react-query';
import { useAuth, ROLE_SI_RH } from '@/contexts/AuthContext';
import { listarMeusEquipamentos, listarTimeRh } from '../../services';

/** Aba "Meus equipamentos" do Portal do SI — só os de quem está logado (pelo e-mail do login). */
export function useMeusEquipamentosQuery() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['si', 'meus-equipamentos', user?.email],
    queryFn: listarMeusEquipamentos,
    enabled: Boolean(user?.email),
  });
}

/** E-mails do time RH (todo mundo com si_rh) — só busca pra quem tem si_rh. */
export function useTimeRhEmailsQuery() {
  const { userHasRole } = useAuth();
  const ehRh = userHasRole(ROLE_SI_RH);
  return useQuery({
    queryKey: ['si', 'time-rh'],
    queryFn: listarTimeRh,
    enabled: ehRh,
    staleTime: 10 * 60 * 1000,
  });
}

/** Quem tem si_rh age como quem abriu nos chamados que outra pessoa do time RH abriu (editar,
 * cancelar/reativar, data prevista) — mesma regra de firestore.rules (siIsTimeRhDoSolicitante). */
export function useEhDoTimeRhDoSolicitante(solicitanteEmail: string | null | undefined): boolean {
  const { userHasRole } = useAuth();
  const { data: emails } = useTimeRhEmailsQuery();
  if (!userHasRole(ROLE_SI_RH) || !solicitanteEmail) return false;
  return (emails ?? []).some((email) => email.toLowerCase() === solicitanteEmail.toLowerCase());
}
